<template>
    <h1>EL CARGADOR DE RECURSOS DEFINITIVO</h1>

    <div>
        <label>Nombre del Recurso</label>
        <input type="text" v-model="nombreDelRecurso">
    </div>  
    <div>  
        <label>Descripcion del Recurso</label>
        <textarea  v-model="descrDelRecurso"></textarea>
    </div>  
    <div>  
        <label>Link del Recurso</label>
        <input type="text" v-model="linkDelRecurso">
    </div>   

    <div>
        <label for="category">CATEGORIA</label>
        <select name="category" id="category" v-model="categorySelect">
            <option value="Dinamica 10 min">Dinamica 10 min</option>
            <option value="Recursos para inspirar">Recursos para inspirar</option>
            <option value="Sabe Más">Sabe Más</option>
            <option value="Dinámica Virtuales/para hacer online ">Dinámica Virtuales/para hacer online </option>
        </select>
    </div>
    <div>
        <label for="topic">TEMÁTICA</label>
        <select name="topic" id="topic" v-model="topicSelect">
            <option value="Desarrollo de habilidades socioemocionales">Desarrollo de habilidades socioemocionales</option>
            <option value="Clima Positivo para aprender">Clima Positivo para aprender</option>
            <option value="Mundo educativo y mundo del trabajo">Mundo educativo y mundo del trabajo</option>
        </select>
    </div>
    <div>
        <div @change="uploadFile($event)" v-if="!fileUploading">
            <label>{{$t('file.UPLOAD_FILE')}}<i class="material-icons">file_upload</i></label>
            <input type="file">
        </div>
        <div v-else>
            <span>Subiendo archivo ...</span>
        </div>
    </div>

    <div>
        <textarea id="queryCompleta">
        </textarea>
    </div>

</template>

<script>
import storage from "@/plugins/azure-storage";
import { useStore } from 'vuex';
import { ref } from 'vue';
import persistentData from '@/plugins/persistentData';

export default {
    components: {
    },
    setup() {
        const store = useStore();
        const fileUploading = ref(false);
        const categorySelect = ref();
        const topicSelect = ref();
        const linkDelRecurso = ref();
        const nombreDelRecurso = ref();
        const descrDelRecurso = ref();
        

        async function uploadFile(event) {
            let file = event.target.files[0];
            if(!file) return false;
            fileUploading.value = true;
            try {
                /* eslint-disable */
                let fileCDN = await storage.updateFile(file,'content');
                const query = 
                    `Insert into ContentCfg (Data, Type, Name, IsResource, Description, IsPublicResource, ResourceCategoryId, ResourceTopicId)` +
                    `Values (` +
                    `'{ `+
                        `"Data":"<div style=\\"width: 100%;\\">     <div style=\\"position: relative; padding-bottom: 56.25%; padding-top: 0; height: 0;\\"><iframe frameborder=\\"0\\" width=\\"1200\\" height=\\"675\\" style=\\"position: absolute; top: 0; left: 0; width: 100%; height: 100%;\\" src=\\"${linkDelRecurso.value}\\" type=\\"text/html\\" allowscriptaccess=\\"always\\" allowfullscreen=\\"true\\" scrolling=\\"yes\\"             allownetworking=\\"all\\"></iframe> </div> </div>", `+
                        `"Preview": "https://lmsforgestoragecdn.azureedge.net/contentresources/${fileCDN}"`+
                    `}', ` +
                    `0, '${nombreDelRecurso.value}', 1, '${descrDelRecurso.value}', 1, ` +
                    `(Select ParentId From ResourceCategory_TF Where Name = '${categorySelect.value}'),` +
                    `(Select ParentId From ResourceTopic_TF Where Name = '${topicSelect.value}'));\r\n`
                console.log(query);
                let arrayQuery = persistentData.get('query');
                if(!arrayQuery){
                    arrayQuery = "";
                }
                arrayQuery += query;
                persistentData.set('query', arrayQuery);
                document.getElementById("queryCompleta").value = arrayQuery;
            } catch {
                store.dispatch('notifications_create',{text:'Error al intentar subir archivo'})
            } finally{
                fileUploading.value = false;
            }
        }


        return{
            fileUploading,
            uploadFile,
            categorySelect,
            topicSelect,
            linkDelRecurso,
            nombreDelRecurso,
            descrDelRecurso
        }
    },
}
</script>
<style lang="scss" scoped>
@import '@/styles/main.scss';

div {
    margin-top: 30px;
    margin-left: 10px;
}

input,select,textarea {
    margin-left: 10px;
    height: 50px;
    width: 90%
}
</style>